/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Editemail_Contacts_Description2Inputs */

const en_coinvestments_editemail_contacts_description2 = /** @type {(inputs: Coinvestments_Editemail_Contacts_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will unlock platform access for all permissioned users at this organisation, even if they are not email recipients. Users will be able to view the deal overview, but must sign the NDA to access sensitive data and documents.`)
};

/**
* | output |
* | --- |
* | "This will unlock platform access for all permissioned users at this organisation, even if they are not email recipients. Users will be able to view the deal ..." |
*
* @param {Coinvestments_Editemail_Contacts_Description2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_editemail_contacts_description2 = /** @type {((inputs?: Coinvestments_Editemail_Contacts_Description2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Editemail_Contacts_Description2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_editemail_contacts_description2(inputs)
});
export { coinvestments_editemail_contacts_description2 as "coInvestments_editEmail_contacts_description" }